import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { adminVerifyCabNumber, adminGetCab, adminAddVendorCab } from '../services/Api'

const AddCab = ({ dataToEdit = null }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const userId = location.state?.userId
  console.log(userId)
  // Form state
  const [formData, setFormData] = useState({
    cabNumber: dataToEdit?.cab_number || '',
    ownByMe: dataToEdit?.own_by_me || false,
    hasCarrier: dataToEdit?.has_carrier || false,
    vehicleImages: {
      vehicle_img: dataToEdit?.vehicle_img || null,
      vehicle_img1: dataToEdit?.vehicle_img1 || null,
      vehicle_img2: dataToEdit?.vehicle_img2 || null,
      vehicle_img3: dataToEdit?.vehicle_img3 || null,
    },
    documents: {
      rc_image: dataToEdit?.rc_image || null,
      cab_number_plate: dataToEdit?.cab_number_plate || null,
      insurance: dataToEdit?.insurance || null,
      permit_certificate: dataToEdit?.permit_certificate || null,
      puc_certificate: dataToEdit?.puc_certificate || null,
      fitness_certificate: dataToEdit?.fitness_certificate || null,
    },
    additionalDetails: dataToEdit?.additional_details || null,
  })

  // UI state
  const [isLoading, setIsLoading] = useState(false)
  const [isVerifying, setIsVerifying] = useState(false)
  const [message, setMessage] = useState({ text: '', type: '' })
  const [isCabVerified, setIsCabVerified] = useState(false)
  const [showImageModal, setShowImageModal] = useState(false)
  const [selectedImage, setSelectedImage] = useState(null)
  const [vehicleTypes, setVehicleTypes] = useState([])
  const [selectedVehicleType, setSelectedVehicleType] = useState(null)

  // Handle cab number input with formatting
  const handleCabNumber = (e) => {
    let value = e.target.value.replace(/[^A-Za-z0-9]/g, '').toUpperCase()

    // Format: RJ-02-SN-6218 (2 letters-2 digits-2 letters-4 digits)
    // let formattedValue = ''
    // if (value.length <= 2) {
    //   formattedValue = value
    // } else if (value.length <= 4) {
    //   formattedValue = value.slice(0, 2) + '-' + value.slice(2)
    // } else if (value.length <= 6) {
    //   formattedValue = value.slice(0, 2) + '-' + value.slice(2, 4) + '-' + value.slice(4)
    // } else {
    //   formattedValue = value.slice(0, 2) + '-' + value.slice(2, 4) + '-' + value.slice(4, 6) + '-' + value.slice(6, 10)
    // }

    setFormData(prev => ({ ...prev, cabNumber: value }))
    setIsCabVerified(false)
  }

  // Handle form input changes
  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }))
  }

  // Handle file uploads
  const handleFileUpload = (type, file, field) => {
    const reader = new FileReader()
    reader.onload = (e) => {
      const fileData = {
        name: file.name,
        type: file.type,
        data: e.target.result,
        file: file
      }

      if (type === 'vehicle') {
        setFormData(prev => ({
          ...prev,
          vehicleImages: { ...prev.vehicleImages, [field]: fileData }
        }))
      } else if (type === 'document') {
        setFormData(prev => ({
          ...prev,
          documents: { ...prev.documents, [field]: fileData }
        }))
      }
    }
    reader.readAsDataURL(file)
  }

  // Verify cab number
  const handleVerifyCabNumber = async () => {
    // if (!formData.cabNumber || formData.cabNumber.length !== 13) {
    //   setMessage({ text: 'Please enter a valid cab number in format RJ-02-SN-6218', type: 'error' })
    //   return
    // }

    setIsVerifying(true)
    setMessage({ text: '', type: '' })

    try {
      const response = await adminVerifyCabNumber(formData.cabNumber)
      console.log('Verification response:', response)

      if (response.data && response.data.success) {
        setMessage({ text: 'Cab number verified successfully!', type: 'success' })
        setIsCabVerified(true)
        handleGetCab()
        setFormData(prev => ({ ...prev, additionalDetails: response.data.data }))
      } else {
        setMessage({ text: response.data?.message || 'Cab number verification failed', type: 'error' })
        setIsCabVerified(false)
      }
    } catch (error) {
      console.error('Verification error:', error)
      setMessage({
        text: error.response?.data?.message || 'Failed to verify cab number. Please try again.',
        type: 'error'
      })
      setIsCabVerified(false)
    } finally {
      setIsVerifying(false)
    }
  }

  // Form validation
  const validateForm = () => {
    const errors = []

    if (!isCabVerified) {
      errors.push('Please verify the cab number first')
    }

    if (!selectedVehicleType) {
      errors.push('Please select a vehicle type')
    }

    const uploadedImages = Object.values(formData.vehicleImages).filter(img => img !== null)
    if (uploadedImages.length < 2) {
      errors.push('At least 2 vehicle images are required')
    }

    return errors
  }

  const handleGetCab = () => {
    setIsLoading(true)
    adminGetCab()
      .then((res) => {
        setIsLoading(false)
        setVehicleTypes(res?.data?.data.reverse())
      })
      .catch((err) => {
        setIsLoading(false)
      })
  }

  // Submit form
  const handleSubmit = async (e) => {
    e.preventDefault()

    const errors = validateForm()
    if (errors.length > 0) {
      setMessage({ text: errors.join(', '), type: 'error' })
      return
    }

    setIsLoading(true)
    setMessage({ text: '', type: '' })

    try {
      // Create FormData for file uploads
      const submitData = new FormData()

      // Add vehicle type
      submitData.append('vehicleType', selectedVehicleType)
      submitData.append('cab_number', formData.cabNumber)
      submitData.append('own_by_me', formData.ownByMe)
      submitData.append('has_carrier', formData.hasCarrier)

      // Add user ID if available
      if (userId) {
        submitData.append('user_id', userId)
      }

      // Add vehicle images
      Object.entries(formData.vehicleImages).forEach(([key, image]) => {
        if (image) {
          submitData.append(key, image.file)
        }
      })

      // Add documents
      Object.entries(formData.documents).forEach(([key, doc]) => {
        if (doc) {
          submitData.append(key, doc.file)
        }
      })

      // Add additional details
      if (formData.additionalDetails) {
        submitData.append('additional_details', JSON.stringify(formData.additionalDetails))
      }

      // Here you would call your API
      console.log('User ID from navigation:', userId)
      adminAddVendorCab(submitData)
        .then((res) => {
          console.log('Response:', res)
          setMessage({ text: 'Cab added successfully!', type: 'success' })
        }).catch((err) => {
          console.log('Error:', err)
          setMessage({ text: 'Failed to add cab. Please try again.', type: 'error' })
        })


      setMessage({ text: dataToEdit ? 'Cab updated successfully!' : 'Cab added successfully!', type: 'success' })

      // Reset form if not editing
      if (!dataToEdit) {
        setFormData({
          cabNumber: '',
          ownByMe: false,
          hasCarrier: false,
          vehicleImages: { vehicle_img: null, vehicle_img1: null, vehicle_img2: null, vehicle_img3: null },
          documents: { rc_image: null, cab_number_plate: null, insurance: null, permit_certificate: null, puc_certificate: null, fitness_certificate: null },
          additionalDetails: null,
        })
        setIsCabVerified(false)
        setSelectedVehicleType(null)
      }

    } catch (error) {
      console.error('Submit error:', error)
      setMessage({
        text: error.response?.data?.message || 'Failed to submit. Please try again.',
        type: 'error'
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="bg-gray-100 min-h-[calc(100vh-80px)] py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        <button className="flex items-center w-fit bg-[#E53935] px-2 py-1 rounded-md active:scale-95 duration-500" onClick={() => navigate(-1)}>
          <svg width="20" height="20" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.5516 21.3393H30.2057C30.6543 21.3393 31.0304 21.1875 31.3339 20.8841C31.6373 20.5806 31.7891 20.2045 31.7891 19.7559C31.7891 19.3073 31.6373 18.9313 31.3339 18.6278C31.0304 18.3243 30.6543 18.1726 30.2057 18.1726H12.5516L17.0641 13.6601C17.3807 13.3434 17.5325 12.974 17.5193 12.5518C17.5061 12.1295 17.3543 11.7601 17.0641 11.4434C16.7474 11.1268 16.3714 10.9618 15.9359 10.9486C15.5005 10.9354 15.1245 11.0872 14.8078 11.4038L7.56406 18.6476C7.40573 18.8059 7.29358 18.9775 7.2276 19.1622C7.16163 19.3469 7.12865 19.5448 7.12865 19.7559C7.12865 19.967 7.16163 20.165 7.2276 20.3497C7.29358 20.5344 7.40573 20.7059 7.56406 20.8643L14.8078 28.108C15.1245 28.4247 15.5005 28.5764 15.9359 28.5632C16.3714 28.55 16.7474 28.3851 17.0641 28.0684C17.3543 27.7518 17.5061 27.3823 17.5193 26.9601C17.5325 26.5379 17.3807 26.1684 17.0641 25.8518L12.5516 21.3393Z" fill="white" />
          </svg>
          <button className="">
            <span className=" text-white ms-1">Back</span>
          </button>
        </button>
        <h1 className="text-4xl font-bold text-center text-red-600 mb-8">
          {dataToEdit ? 'Edit Cab Details' : 'Add Cab Details'}
        </h1>

        {/* Message Display */}
        {message.text && (
          <div className={`mb-6 p-4 rounded-lg ${message.type === 'success'
            ? 'bg-green-100 border border-green-400 text-green-700'
            : 'bg-red-100 border border-red-400 text-red-700'
            }`}>
            {message.text}
          </div>
        )}

        {/* Cab Number Verification Section */}
        {!isCabVerified && (
          <div className="bg-white rounded-xl shadow-lg p-6 mb-8">
            <div className="max-w-2xl mx-auto">
              <label className="block text-lg font-semibold text-gray-700 mb-3">
                Vehicle Number <span className="text-red-500">*</span> <span className="text-sm text-gray-500 font-normal">(Format: AB-12-CD-3456)</span>
              </label>
              <div className="flex gap-4 items-end">
                <div className="flex-1">
                  <input
                    type="text"
                    value={formData.cabNumber}
                    placeholder="AB-12-CD-3456"
                    className="w-full p-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent text-lg"
                    onChange={handleCabNumber}
                    maxLength={13}
                    disabled={isVerifying}
                  />
                </div>
                <button
                  type="button"
                  className="bg-blue-600 text-white px-8 py-4 rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors font-semibold"
                  onClick={handleVerifyCabNumber}
                  disabled={isVerifying || !formData.cabNumber}
                >
                  {isVerifying ? 'Verifying...' : 'Verify'}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Main Form */}
        {isCabVerified && (
          <form onSubmit={handleSubmit} className="space-y-8">
            {/* Cab Information Section */}
            <div className="bg-white rounded-xl shadow-lg p-6">
              <h2 className="text-2xl font-bold text-red-600 mb-6 pb-3 border-b-2 border-gray-100">
                Cab Information
              </h2>

              {/* Vehicle Images */}
              <div className="mb-8">
                <label className="block text-lg font-semibold text-gray-700 mb-4">
                  Vehicle Images <span className="text-red-500">(minimum 2 Images required)*</span>
                </label>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                  {Object.entries(formData.vehicleImages).map(([key, image]) => (
                    <div key={key} className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center hover:border-red-500 transition-colors">
                      {image ? (
                        <div className="relative">
                          <img src={image.data} alt={`Vehicle ${key}`} className="w-full h-32 object-cover rounded-lg" />
                          <button
                            type="button"
                            className="absolute top-2 right-2 bg-red-600 text-white rounded-full w-8 h-8 flex items-center justify-center hover:bg-red-700"
                            onClick={() => document.getElementById(`${key}-input`).click()}
                          >
                            ✏️
                          </button>
                        </div>
                      ) : (
                        <div className="h-32 flex flex-col items-center justify-center">
                          <input
                            id={`${key}-input`}
                            type="file"
                            accept="image/*"
                            className="hidden"
                            onChange={(e) => {
                              const file = e.target.files[0]
                              if (file) handleFileUpload('vehicle', file, key)
                            }}
                          />
                          <button
                            type="button"
                            className="bg-gray-100 border border-gray-300 px-4 py-2 rounded-lg hover:bg-gray-200 transition-colors text-sm"
                            onClick={() => document.getElementById(`${key}-input`).click()}
                          >
                            📷 Upload Cab Image
                          </button>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>

              {/* Vehicle Type Selection */}
              <div className="mb-6">
                <label className="block text-lg font-semibold text-gray-700 mb-3">
                  Select Vehicle Type <span className="text-red-500">*</span>
                </label>
                <select
                  className="w-full p-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent text-lg"
                  value={selectedVehicleType || ''}
                  onChange={(e) => setSelectedVehicleType(e.target.value)}
                >
                  <option value="">Select Vehicle Type</option>
                  {vehicleTypes.map(type => (
                    <option key={type._id} value={type._id}>{type.vehicleType}</option>
                  ))}
                </select>
              </div>

              {/* Vehicle Information */}
              {formData.additionalDetails && (
                <div className="bg-gray-50 rounded-lg p-6">
                  <h3 className="text-xl font-semibold text-gray-800 mb-4">Vehicle Details</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Cab license plate number</label>
                      <input
                        type="text"
                        value={formData.additionalDetails.rc_number || ''}
                        readOnly
                        className="w-full p-3 border border-gray-300 rounded-lg bg-gray-100 text-gray-600"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Color</label>
                      <input
                        type="text"
                        value={formData.additionalDetails.color || ''}
                        readOnly
                        className="w-full p-3 border border-gray-300 rounded-lg bg-gray-100 text-gray-600"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Date of purchase</label>
                      <input
                        type="text"
                        value={formData.additionalDetails.registration_date || ''}
                        readOnly
                        className="w-full p-3 border border-gray-300 rounded-lg bg-gray-100 text-gray-600"
                        placeholder="YYYY-MM-DD"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Year</label>
                      <input
                        type="text"
                        value={formData.additionalDetails.manufacturing_date_formatted?.split("-")[0] || ''}
                        readOnly
                        className="w-full p-3 border border-gray-300 rounded-lg bg-gray-100 text-gray-600"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Vehicle model</label>
                      <input
                        type="text"
                        value={formData.additionalDetails.maker_model || ''}
                        readOnly
                        className="w-full p-3 border border-gray-300 rounded-lg bg-gray-100 text-gray-600"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Fuel Type</label>
                      <input
                        type="text"
                        value={formData.additionalDetails.fuel_type || ''}
                        readOnly
                        className="w-full p-3 border border-gray-300 rounded-lg bg-gray-100 text-gray-600"
                      />
                    </div>
                    <div className="md:col-span-2">
                      <label className="flex items-center">
                        <input
                          type="checkbox"
                          checked={formData.hasCarrier}
                          onChange={(e) => handleInputChange('hasCarrier', e.target.checked)}
                          className="mr-3 h-5 w-5 text-red-600 focus:ring-red-500"
                        />
                        <span className="text-lg font-medium text-gray-700">Has Carrier</span>
                      </label>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Vehicle owner's name</label>
                      <input
                        type="text"
                        value={formData.additionalDetails.owner_name || ''}
                        className="w-full p-3 border border-gray-300 rounded-lg bg-gray-100 text-gray-600"
                        onChange={(e) => setFormData(prev => ({
                          ...prev,
                          additionalDetails: {
                            ...prev.additionalDetails,
                            owner_name: e.target.value
                          }
                        }))}
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Registration end date</label>
                      <input
                        type="text"
                        value={formData.additionalDetails.fit_up_to || ''}
                        readOnly
                        className="w-full p-3 border border-gray-300 rounded-lg bg-gray-100 text-gray-600"
                        placeholder="YYYY-MM-DD"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Tax paid until date</label>
                      <input
                        type="text"
                        value={formData.additionalDetails.tax_upto || ''}
                        readOnly
                        className="w-full p-3 border border-gray-300 rounded-lg bg-gray-100 text-gray-600"
                        placeholder="YYYY-MM-DD"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Commercial Permit end-date</label>
                      <input
                        type="text"
                        value={formData.additionalDetails.permit_valid_upto || ''}
                        readOnly
                        className="w-full p-3 border border-gray-300 rounded-lg bg-gray-100 text-gray-600"
                        placeholder="YYYY-MM-DD"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Fitness Expiry Date</label>
                      <input
                        type="text"
                        value={formData.additionalDetails.fit_up_to || ''}
                        readOnly
                        className="w-full p-3 border border-gray-300 rounded-lg bg-gray-100 text-gray-600"
                        placeholder="YYYY-MM-DD"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Insurance Expiry Date</label>
                      <input
                        type="text"
                        value={formData.additionalDetails.insurance_upto || ''}
                        readOnly
                        className="w-full p-3 border border-gray-300 rounded-lg bg-gray-100 text-gray-600"
                        placeholder="YYYY-MM-DD"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">PUC Expiry Date</label>
                      <input
                        type="text"
                        value={formData.additionalDetails.pucc_upto || ''}
                        readOnly
                        className="w-full p-3 border border-gray-300 rounded-lg bg-gray-100 text-gray-600"
                        placeholder="YYYY-MM-DD"
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Documents Section */}
            <div className="bg-white rounded-xl shadow-lg p-6">
              <h2 className="text-2xl font-bold text-red-600 mb-6 pb-3 border-b-2 border-gray-100">
                Documents
              </h2>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {[
                  { id: 'rc_image', name: 'RC Book' },
                  { id: 'cab_number_plate', name: 'Cab Number Plate' },
                  { id: 'insurance', name: 'Insurance' },
                  { id: 'permit_certificate', name: 'Permit Certificate' },
                  { id: 'puc_certificate', name: 'PUC Certificate' },
                  { id: 'fitness_certificate', name: 'Fitness Certificate' },
                ].map((doc) => (
                  <div key={doc.id} className="bg-gray-50 border border-gray-200 rounded-lg p-4">
                    <div className="flex justify-between items-center mb-3">
                      <h3 className="text-lg font-semibold text-gray-800">{doc.name}</h3>
                      <span className={`px-3 py-1 rounded-full text-xs font-semibold ${formData.documents[doc.id]
                        ? 'bg-green-100 text-green-800'
                        : 'bg-red-100 text-red-800'
                        }`}>
                        {formData.documents[doc.id] ? 'Uploaded' : 'Pending'}
                      </span>
                    </div>

                    <div className="text-center">
                      {formData.documents[doc.id] ? (
                        <div>
                          <img
                            src={formData.documents[doc.id].data}
                            alt={doc.name}
                            className="w-full h-32 object-cover rounded-lg mb-3 cursor-pointer hover:opacity-80 transition-opacity"
                            onClick={() => {
                              setSelectedImage(formData.documents[doc.id].data)
                              setShowImageModal(true)
                            }}
                          />
                          <div className="flex gap-2">
                            <button
                              type="button"
                              className="flex-1 bg-blue-600 text-white px-3 py-2 rounded-lg hover:bg-blue-700 transition-colors text-sm"
                              onClick={() => {
                                setSelectedImage(formData.documents[doc.id].data)
                                setShowImageModal(true)
                              }}
                            >
                              View
                            </button>
                            <button
                              type="button"
                              className="flex-1 bg-red-600 text-white px-3 py-2 rounded-lg hover:bg-red-700 transition-colors text-sm"
                              onClick={() => handleInputChange('documents', { ...formData.documents, [doc.id]: null })}
                            >
                              Remove
                            </button>
                          </div>
                        </div>
                      ) : (
                        <div className="h-32 flex items-center justify-center border-2 border-dashed border-gray-300 rounded-lg mb-3">
                          <input
                            id={`${doc.id}-input`}
                            type="file"
                            accept="image/*"
                            className="hidden"
                            onChange={(e) => {
                              const file = e.target.files[0]
                              if (file) handleFileUpload('document', file, doc.id)
                            }}
                          />
                          <button
                            type="button"
                            className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition-colors text-sm"
                            onClick={() => document.getElementById(`${doc.id}-input`).click()}
                          >
                            📄 Upload {doc.name}
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Submit Button */}
            <div className="flex justify-center">
              <button
                type="submit"
                className="bg-red-600 text-white px-12 py-4 rounded-lg hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors font-semibold text-lg"
                disabled={isLoading}
              >
                {isLoading ? 'Saving...' : (dataToEdit ? 'Update Cab' : 'Add Cab')}
              </button>
            </div>
          </form>
        )}

        {/* Image Modal */}
        {showImageModal && (
          <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50" onClick={() => setShowImageModal(false)}>
            <div className="relative max-w-4xl max-h-[90vh] bg-white rounded-lg overflow-hidden" onClick={(e) => e.stopPropagation()}>
              <button
                className="absolute top-4 right-4 bg-black bg-opacity-50 text-white rounded-full w-10 h-10 flex items-center justify-center hover:bg-opacity-75 z-10"
                onClick={() => setShowImageModal(false)}
              >
                ×
              </button>
              <img src={selectedImage} alt="Preview" className="w-full h-auto max-h-[90vh] object-contain" />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default AddCab
